import React from "react";
import { Tupel } from "components";
import { TVehicle } from "types";
import { Box } from "@mui/material";

interface IDetail {
  vehicle: TVehicle;
  financeRate?: any;
  short?: boolean;
}

const Purchase: React.FC<IDetail> = ({ financeRate, vehicle }): JSX.Element => {
  const { preis_fracht_vk_brutto } = vehicle;
  const labelId =
    preis_fracht_vk_brutto && preis_fracht_vk_brutto > 0
      ? "common.kaufpreis-mit-fracht"
      : "common.kaufpreis";

  const vatFactor = financeRate.customerType === "business" ? 1.19 : 1;
  const vatInformation =
    financeRate.customerType === "business"
      ? "netto zuzüglich MwSt., nur für Gewerbekunden"
      : "inkl. MwSt.";
  return (
    <Box>
      <Tupel
        labelId={labelId}
        euro={vehicle.preis / vatFactor}
        digits={2}
        boxProps={{ fontWeight: "bold" }}
        information={vatInformation}
        informationPosition="right"
      />
      <Tupel
        labelId="common.type"
        textId={
          "filter.financial.v2.rateType.options.buy" +
          financeRate.customerType +
          ".label"
        }
        text={
          financeRate.customerType === "business"
            ? "gewerblicher Barkauf"
            : "Barkauf"
        }
      />
    </Box>
  );
};

export default Purchase;
